import Image from '@/components/UI/Image';
import Input from '@/components/UI/Input';
import { ENGLISH_LANG, rpcMap } from '@/constants';
import { MODAL_TYPE } from '@/constants/cooperation';
import { getCitiesList, getCountriesList, getStatesList } from '@/service';
import { submitFreeQuoteToB } from '@/service/quote';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { message as antdMessage, Button, Checkbox, Form, Select } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/cooperation/');

type Option = {
    key?: number | string;
    label: string;
    value: string;
};

export default function G() {
    const { useLang, gtm } = useGlobal();
    const { t: s } = useLang('shared');
    const { t } = useLang('powerstreamcooperation');
    const router = useRouter();
    const { locale = 'us' } = router;
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY_TO_B;
    const recaptchaRef = useRef();
    const [countries, setCountries] = useState<any>([]);
    const [states, setStates] = useState<any>([]);
    const [cities, setCities] = useState<any>([]);
    const [recaptchaResponse, setRecaptchaResponse] = useState('');
    const [prefixCode, setPrefixCode] = useState('');
    const [step, setStep] = useState(MODAL_TYPE.DETAIL);
    const [isLoading, setIsLoading] = useState(false);
    const [showCompanyTypeSpecify, setShowCompanyTypeSpecify] = useState(false);
    const [selectOpen, setSelectOpen] = useState({
        countryOpen: false,
        provinceOpen: false,
        cityOpen: false,
        companyType: false,
        businessCategory: false,
        productInterests: false,
        productCategory: false,
    });
    const [form] = Form.useForm();
    const hl = rpcMap[ENGLISH_LANG.includes(locale) ? 'en' : locale];

    const OTHER_STATE: Option[] = [
        {
            key: 404,
            value: t('other_state'),
            label: t('other_state'),
        },
    ];
    const OTHER_CITY: Option[] = [
        {
            key: 404,
            value: t('other_city'),
            label: t('other_city'),
        },
    ];
    const companyTypeOption1: Option[] = [
        {
            label: t('site_dealer_companyType_item1'),
            value: 'Distributor',
        },
        {
            label: t('site_dealer_companyType_item2'),
            value: 'Installer',
        },
        {
            label: t('site_dealer_companyType_item3'),
            value: 'Electrician',
        },
        {
            label: t('site_dealer_companyType_item4'),
            value: 'Homeowner',
        },
        {
            label: t('site_dealer_companyType_item5'),
            value: 'Consultant',
        },
        {
            label: t('site_dealer_companyType_item6'),
            value: 'Media',
        },
        {
            label: t('site_dealer_companyType_item7'),
            value: 'Wholesaler',
        },
        {
            label: t('site_dealer_companyType_item9'),
            value: 'Others',
        },
    ];
    const companyTypeOption2: Option[] = [
        {
            label: t('site_dealer_companyType_item1'),
            value: 'Distributor',
        },
        {
            label: t('site_dealer_companyType_item7'),
            value: 'Wholesaler',
        },
        {
            label: t('site_dealer_companyType_item8'),
            value: 'Retailer',
        },
        {
            label: t('site_dealer_companyType_item9'),
            value: 'Others',
        },
    ];
    const [companyTypeOption, setCompanyTypeOption] = useState(companyTypeOption1);
    const productInterestsOption: Option[] = [
        {
            label: t('site_dealer_product_interests_item1'),
            value: 'Home solar battery solution',
        },
        {
            label: t('site_dealer_product_interests_item2'),
            value: 'Power stations',
        },
        {
            label: t('site_dealer_product_interests_item3'),
            value: 'Balcony power plants',
        },
        {
            label: t('site_dealer_product_interests_item4'),
            value: 'Solar panels',
        },
        {
            label: t('site_dealer_product_interests_item5'),
            value: 'Smart devices',
        },
        {
            label: t('site_dealer_product_interests_item6'),
            value: 'Others',
        },
    ];
    const productCategoryOption = [
        {
            label: t('site_dealer_productCategory_item5'),
            value: t('site_dealer_productCategory_item5'),
        },
        {
            label: t('site_dealer_productCategory_item6'),
            value: t('site_dealer_productCategory_item6'),
        },
        {
            label: t('site_dealer_productCategory_item1'),
            value: t('site_dealer_productCategory_item1'),
        },
        {
            label: t('site_dealer_productCategory_item2'),
            value: t('site_dealer_productCategory_item2'),
        },
        {
            label: t('site_dealer_productCategory_item3'),
            value: t('site_dealer_productCategory_item3'),
        },
        {
            label: t('site_dealer_productCategory_item4'),
            value: t('site_dealer_productCategory_item4'),
        },
        {
            label: t('site_dealer_productCategory_item7'),
            value: t('site_dealer_productCategory_item7'),
        },
        {
            label: t('site_dealer_productCategory_item8'),
            value: t('site_dealer_productCategory_item8'),
        },
        {
            label: t('site_dealer_productCategory_item9'),
            value: t('site_dealer_productCategory_item9'),
        },
    ];

    const onFinish = async (values: any) => {
        const params: any = {
            businessCategory: ' ',
            ...values,
            email: values.email.trim(),
            phoneCode: prefixCode,
            recaptchaResponse,
            optIn: !!values.optIn,
        };
        //  jp改版后country字段不再展示了
        if (locale === 'jp') {
            params.country = 'Japan';
        }
        setIsLoading(true);
        try {
            params['addressLineTwo'] = params.address2;
            params['postalCode'] = params.zipCode;
            params['phoneNumber'] = params.phoneCode + params.phone;
            params['identity'] = params.companyType;
            params['interestedProductCategory'] = params.productInterests;
            const res = await submitFreeQuoteToB(params, locale);
            setIsLoading(false);
            if (res.code === '0') {
                form.resetFields();
                setStep(MODAL_TYPE.SUCCESS);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'become_dealer_submit',
                    status: 'success',
                });
                antdMessage.success(res?.message || 'Success');
            } else {
                setRecaptchaResponse('');
                const rptRef: any = recaptchaRef.current;
                rptRef.reset();
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'become_dealer_submit',
                    status: 'fail',
                });
                antdMessage.error(res?.message);
            }
            /* @ts-ignore */
            window?.lintrk('track', { conversion_id: 13465498 });
            /* @ts-ignore */
            window?.fbq && window?.fbq('track', 'Lead');
        } catch (err: any) {
            setIsLoading(false);
            console.log('err:', err);
            gtm.push({
                event: 'uaEvent',
                event_name: 'become_dealer_submit',
                status: 'fail',
            });
        }
    };

    const getCountry = async () => {
        const firstCountries = [
            {
                key: 82,
                label: 'Germany',
                value: 'Germany',
                phoneCode: '+49',
            },
            {
                key: 15,
                label: 'Austria',
                value: 'Austria',
                phoneCode: '+43',
            },
            {
                key: 214,
                label: 'Switzerland',
                value: 'Switzerland',
                phoneCode: '+41',
            },
        ];
        // 因国家/省/市列表只有英文的，所以暂时写死语言为 us
        const result: any = await getCountriesList(
            {
                page: 1,
                size: 300,
            },
            'us',
        );
        if (result?.code === '0') {
            const countryList: any = [];
            result.data?.content?.forEach((item: any) => {
                countryList.push({
                    key: item.id,
                    text: item.name,
                    phoneCode: item.phoneCode,
                });
            });
            countryList.push({
                key: 404,
                text: t('other_country'),
                phoneCode: '',
            });
            setCountries(countryList);
        }
    };

    const getStates = async (id: number) => {
        try {
            const res: any = await getStatesList({
                countryId: id,
                page: 1,
                size: 300,
            });
            if (res.code === '0') {
                const stateList = res.data?.content?.map((item: any) => ({
                    key: item.id,
                    value: item.name,
                    label: item.name,
                }));
                setStates(stateList.concat(OTHER_STATE));
                return stateList;
            } else {
                antdMessage.error(res?.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getCity = async (id: number) => {
        try {
            const res: any = await getCitiesList({
                stateId: id,
                page: 1,
                size: 3000,
            });

            if (res.code === '0') {
                const cityList: any = res.data?.content?.map((item: any) => ({
                    key: item.id,
                    label: item.name,
                    value: item.name,
                }));
                setCities(cityList.concat(OTHER_CITY));
            } else {
                antdMessage.error(res?.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onCountryChange = (_val: any, option: any) => {
        // select组件重置值，也会把placeholder清除，所以提前获取值判断是否存在值
        form.setFieldsValue({
            state: undefined,
        });
        form.setFieldsValue({
            city: undefined,
        });
        const target = countries.filter((item: any) => item.key === Number(option.key));
        getStates(option.key);
        setPrefixCode(target[0]?.phoneCode);
        setCities([]);
    };

    const onStateChange = (_val: any, option: any) => {
        form.setFieldsValue({
            city: undefined,
        });
        getCity(option.key);
    };

    const onProductInterestsChange = (item: any) => {
        setCompanyTypeOption(item === productInterestsOption[0]?.value ? companyTypeOption1 : companyTypeOption2);
        form.setFieldsValue({
            companyType: undefined,
        });
    };

    const onReCAPTCHAChange = async (captchaCode: string) => {
        if (!captchaCode) return;
        setRecaptchaResponse(captchaCode);
        // form.validateFields(['recaptchaResponse']);
        form.setFieldsValue({
            recaptchaResponse: captchaCode,
        });
    };

    const onCompanyTypeChange = (item: any) => setShowCompanyTypeSpecify(item.value?.trim() === 'Others');

    useEffect(() => {
        getCountry();
    }, []);

    return (
        <div id="powerstream-cooperation-G" className={`powerstream-cooperation-G ${css['powerstream-cooperation-G']}`}>
            <div className="base-box form-box">
                <div className="form-content">
                    {step === MODAL_TYPE.DETAIL && (
                        <div id="cooperation-form">
                            <div className="top-title">{t('site_dealer_become_a_dealer')}</div>
                            <div className="top-desc">{t('site_dealer_become_a_dealer_remark')}</div>
                            <Form name="cooperation" form={form} layout="vertical" onFinish={onFinish}>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_table_first_name')}
                                        name="firstName"
                                        required
                                        rules={[
                                            {
                                                validator(_: any, value: any) {
                                                    const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                    if (!value || value?.length > 30 || !regx.test(value)) {
                                                        return Promise.reject(s('user.site_account_profile_firstname_wrong_tip'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="default-input"
                                            placeholder={t('site_dealer_table_first_name')}
                                            aria-label={t('site_dealer_table_first_name')}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('site_dealer_table_last_name')}
                                        name="lastName"
                                        required
                                        rules={[
                                            {
                                                validator(_: any, value: any) {
                                                    const regx = /^((?!\d|\+|&|=|\_|'|-|,|<|>|\.{2,}).){1,30}$/;
                                                    if (!value || value?.length > 30 || !regx.test(value)) {
                                                        return Promise.reject(s('user.site_account_profile_lastname_wrong_tip'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="default-input"
                                            placeholder={t('site_dealer_table_last_name')}
                                            aria-label={t('site_dealer_table_last_name')}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_table_country')}
                                        name="country"
                                        required
                                        rules={[
                                            {
                                                validator: (_rule, value) =>
                                                    value ? Promise.resolve() : Promise.reject(s('user.site_account_profile_country_select_wrong_tip')),
                                            },
                                        ]}
                                    >
                                        <Select
                                            // style={{ width: 336 }}
                                            className="ef-comp-selector"
                                            placeholder={t('site_dealer_table_country')}
                                            onChange={onCountryChange}
                                            optionFilterProp="children"
                                            showSearch
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    countryOpen: open,
                                                })
                                            }
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.countryOpen ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                        >
                                            {countries?.map((item: any) => (
                                                <Select.Option value={item.text} key={item.key}>
                                                    {item.text}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item label={t('site_dealer_table_state')} name="state">
                                        <Select
                                            className="ef-comp-selector"
                                            onChange={onStateChange}
                                            placeholder={t('site_dealer_table_state')}
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    provinceOpen: open,
                                                })
                                            }
                                            optionFilterProp="children"
                                            showSearch
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.provinceOpen ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                        >
                                            {states?.map((item: any) => (
                                                <Select.Option value={item.value} key={item.key}>
                                                    {item.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_table_city')}
                                        name="city"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Select
                                            className="ef-comp-selector"
                                            placeholder={t('site_dealer_table_city')}
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    cityOpen: open,
                                                })
                                            }
                                            optionFilterProp="children"
                                            showSearch
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.cityOpen ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                        >
                                            {cities?.map((item: any) => (
                                                <Select.Option value={item.value} key={item.key}>
                                                    {item.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label={t('site_dealer_table_postal_zip_code')}
                                        name="zipCode"
                                        required
                                        rules={[
                                            {
                                                validator(_: any, value: any) {
                                                    const regx = /^[a-zA-Z0-9\s]{1,50}$/;
                                                    if (!value || !regx.test(value)) {
                                                        return Promise.reject(s('user.site_account_address_zip_wrong_tip'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="default-input"
                                            placeholder={t('site_dealer_table_postal_zip_code')}
                                            aria-label={t('site_dealer_table_postal_zip_code')}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_table_phone')}
                                        name="phone"
                                        required
                                        rules={[
                                            {
                                                validator(_: any, value: any) {
                                                    const regx = /^[0-9+]{7,20}$/;
                                                    if (!regx.test(value)) {
                                                        return Promise.reject(s('my.site_account_address_phone_wrong_tip'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="default-input vertical-line"
                                            placeholder={t('site_dealer_table_phone')}
                                            aria-label={t('site_dealer_table_phone')}
                                            prefix={
                                                prefixCode && (
                                                    <>
                                                        <span>{prefixCode}</span>
                                                        <div className="divider"></div>
                                                    </>
                                                )
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('site_dealer_table_email_address')}
                                        name="email"
                                        rules={[
                                            {
                                                validator: async (_: any, value: any) => {
                                                    const regx =
                                                        /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
                                                    if (!regx.test(value)) {
                                                        return Promise.reject(s('logintips.site_login_tip_email_format_incorrect'));
                                                    }
                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                        validateTrigger="onBlur"
                                        required
                                    >
                                        <Input
                                            className="default-input"
                                            placeholder={t('site_dealer_table_email_address')}
                                            aria-label={t('site_dealer_table_email_address')}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_table_company_name')}
                                        name="companyName"
                                        rules={[
                                            {
                                                required: true,
                                                message: s('my.site_account_address_phone_wrong_tip'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="default-input"
                                            placeholder={t('site_dealer_table_company_name')}
                                            aria-label={t('site_dealer_table_company_name')}
                                            maxLength={100}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('site_dealer_product_interests')}
                                        name="productInterests"
                                        rules={[
                                            {
                                                required: true,
                                                message: t('site_dealer_table_category_wrong'),
                                            },
                                        ]}
                                    >
                                        <Select
                                            className="ef-comp-selector"
                                            placeholder={t('site_dealer_product_interests')}
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    productInterests: open,
                                                })
                                            }
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.productInterests ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                            onChange={(item) => onProductInterestsChange(item)}
                                        >
                                            {productInterestsOption?.map((option: any) => (
                                                <Select.Option key={option?.value} value={option?.value}>
                                                    {option?.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div className="two-colums">
                                    <Form.Item
                                        label={t('site_dealer_type_of_company')}
                                        name="companyType"
                                        rules={[
                                            {
                                                required: true,
                                                message: t('site_dealer_table_type_company_wrong'),
                                            },
                                        ]}
                                    >
                                        <Select
                                            className="ef-comp-selector"
                                            placeholder={t('site_dealer_i_am_a')}
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    companyType: open,
                                                })
                                            }
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.companyType ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                            onChange={(item) => onCompanyTypeChange(item)}
                                        >
                                            {companyTypeOption?.map((option: any) => (
                                                <Select.Option key={option?.value} value={option?.value}>
                                                    {option?.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    {/* new input */}
                                    {showCompanyTypeSpecify && (
                                        <Form.Item className="no-label" name="companyTypeSpecify">
                                            <Input
                                                style={{ width: 336, marginTop: 30 }}
                                                className="default-input full-width"
                                                placeholder={t('site_dealer_please_specify')}
                                                aria-label={t('site_dealer_please_specify')}
                                                maxLength={49}
                                            />
                                        </Form.Item>
                                    )}
                                </div>
                                <Form.Item
                                    name="companyWebsite"
                                    rules={[
                                        {
                                            validator(_: any, value: any) {
                                                const regx = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
                                                if (value && !regx.test(value)) {
                                                    return Promise.reject(new Error(s('user.site_account_address_company_website_wrong_tip')));
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                    label={t('site_dealer_table_company_website')}
                                >
                                    <Input
                                        className="default-input full-width"
                                        placeholder={t('site_dealer_table_company_website')}
                                        aria-label={t('site_dealer_table_company_website')}
                                        maxLength={150}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="companyAddress"
                                    label={t('site_dealer_table_company_address')}
                                    rules={[
                                        {
                                            required: true,
                                            message: s('user.site_account_address_address_wrong_tip'),
                                        },
                                    ]}
                                >
                                    <Input
                                        className="default-input full-width"
                                        placeholder={t('site_dealer_table_company_address')}
                                        aria-label={t('site_dealer_table_company_address')}
                                        maxLength={255}
                                    />
                                </Form.Item>
                                <Form.Item name="address2" label={t('site_dealer_table_address_line2')}>
                                    <Input
                                        className="default-input full-width"
                                        placeholder={t('site_dealer_table_address_line2')}
                                        aria-label={t('site_dealer_table_address_line2')}
                                        maxLength={255}
                                    />
                                </Form.Item>
                                {locale === 'ca' && (
                                    <Form.Item label={t('site_dealer_interested')} name="productCategory">
                                        <Select
                                            className="ef-comp-selector full-width"
                                            placeholder={t('site_dealer_interested')}
                                            onDropdownVisibleChange={(open) =>
                                                setSelectOpen({
                                                    ...selectOpen,
                                                    productCategory: open,
                                                })
                                            }
                                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                            suffixIcon={
                                                <div
                                                    style={{
                                                        transform: `rotate(${selectOpen.productCategory ? '90deg' : '0deg'})`,
                                                    }}
                                                >
                                                    <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('site_dealer_icon')} />
                                                </div>
                                            }
                                            dropdownClassName="ef-select-item"
                                            options={productCategoryOption}
                                        />
                                    </Form.Item>
                                )}
                                <Form.Item name="message" label={t('site_dealer_table_message')}>
                                    <Input.TextArea
                                        className="default-input full-width"
                                        placeholder={t('site_dealer_table_message_placeholder')}
                                        aria-label={t('site_dealer_table_message_placeholder')}
                                        maxLength={2000}
                                        showCount={true}
                                        autoSize={{ minRows: 3 }}
                                    />
                                </Form.Item>
                                <Form.Item name="optIn" className="checkbox" valuePropName="checked">
                                    <Checkbox>{t('cooperation_form_checkbox')}</Checkbox>
                                </Form.Item>

                                <div>
                                    <Form.Item
                                        name="recaptchaResponse"
                                        rules={[
                                            {
                                                validator() {
                                                    if (recaptchaResponse) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(s('logintips.site_login_tip_perform_verification'));
                                                },
                                            },
                                        ]}
                                    >
                                        <div className="g-recaptcha">
                                            {/* @ts-ignore */}
                                            <ReCAPTCHA ref={recaptchaRef} hl={hl} sitekey={SECRET_KEY} onChange={onReCAPTCHAChange} />
                                        </div>
                                    </Form.Item>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="black-btn submit-btn"
                                            loading={isLoading}
                                            aria-label={t('site_dealer_table_submit')}
                                        >
                                            {t('site_dealer_table_submit')}
                                        </Button>
                                    </Form.Item>
                                </div>
                            </Form>
                        </div>
                    )}
                    {step === MODAL_TYPE.SUCCESS && (
                        <div className="register-success-wrapper">
                            <div className="img-wrapper">
                                <EFPic
                                    name={['register-success.webp', 'register-success.png']}
                                    alt={t('site_dealer_table_submit_success')}
                                    className="registerSuccess"
                                />
                            </div>
                            <div className="title">{t('site_dealer_table_submit_success')}</div>
                            <div className="desc">{t('site_dealer_table_submit_success_tip')}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
